import * as React from 'react';
import { useIntl } from 'react-intl';

import { Styled } from './character-counter.styles';
import type { CharacterCounterProps } from './character-counter.types';

export const CharacterCounter = React.forwardRef<
  HTMLParagraphElement,
  CharacterCounterProps
>(({ currentCount, maxCount }, forwardedRef) => {
  const intl = useIntl();

  return (
    <Styled.CharacterCounter
      $maxCountReached={currentCount > maxCount}
      aria-atomic="true"
      aria-label={`${intl.formatMessage(
        {
          id: 'XDS_A11Y_CHARACTER_COUNTER_TEXT',
          defaultMessage: '{currentCount} of {maxCount} characters used',
        },
        { currentCount, maxCount }
      )}${
        currentCount > maxCount
          ? `, ${intl.formatMessage({
              id: 'XDS_A11Y_CHARACTER_COUNTER_MAX',
              defaultMessage: 'maximum exceeded',
            })}`
          : ''
      }`}
      aria-live="polite"
      ref={forwardedRef}
      role="status"
      size="xsmall"
    >
      {currentCount}/{maxCount}
    </Styled.CharacterCounter>
  );
});

CharacterCounter.displayName = 'CharacterCounter';
